import { Vector3 } from "three";
import PrototypeImpl from "../PrototypeImpl.ts";

type TileProps = {
  tilePosition: Vector3;
  prototype: PrototypeImpl;
};

export default function ErrorTile({
  tilePosition,
  prototype,
}: TileProps): JSX.Element {
  return (
    <mesh
      position={tilePosition}
      onClick={() => console.log("clicked error tile", tilePosition, prototype)}
    >
      <boxGeometry args={[0.9, 0.9, 0.9]} />
      <meshStandardMaterial color="red" />
    </mesh>
  );
}
